<template>
    <div>
        <error-blocked-lock
            :title="$t.__('pages.errors.ErrorBlocked.account_blocked')"
            :subtitles="[$t.__('pages.errors.ErrorBlocked.to_continue_contact_us')]"
        >
            <a
                href="javascript:;"
                onclick="MySupport.getForm();"
                class="primary-50-bkg white br fs-4 lh-24 pt-2 pb-2 pl-4 pr-4 semibold"
            >
                {{ $l10n.__('Contacter un commercial') }}
            </a>
            <div class="fs-4 lh-24 semibold mt-4" v-html="tchat"></div>
        </error-blocked-lock>
    </div>
</template>

<script>
import ErrorBlockedLock from 'vcomponents/pages/errors/ErrorBlockedLock.vue';

export default {
    components: {
        ErrorBlockedLock,
    },
    computed: {
        tchat: function () {
            return this.$l10n.__('Ou revenir sur %(startTag)s sellsy.com %(endTag)s', {
                startTag: '<a href="https://go.sellsy.com" class="link fs-4 lh-24 semibold">',
                endTag: '</a>',
            });
        },
    },
};
</script>
